/**
 * A custom error class that extends the built-in Error class with additional properties.
 * This class is designed to handle known error cases with specific error codes and optional data.
 *
 * @template ErrorCode - A string literal type that represents the specific error code
 */
export class KnownError extends Error {
    /**
     * Creates a new instance of KnownError
     *
     * @param input - The input object containing error details
     * @param input.code - The specific error code for this error
     * @param input.data - Optional additional data associated with this error
     * @param input.message - Optional error message. If not provided, the error code will be used
     */
    constructor(input) {
        super(input.message);
        this.code = input.code;
        this.data = input.data;
    }
}
